import {css, html, LitElement} from "lit";
import {pxToRem} from "../styles";
import "../badge/badge";
import "../icon/icon";

export class WlShowMore extends LitElement {
    private viewMoreLabel: string = 'View more';
    private viewLessLabel: string = 'View less';

    static get properties() {
        return {
            viewMoreLabel: {type: String},
            viewLessLabel: {type: String},
        }
    }

    constructor() {
        super()
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                width: 100%;
                flex-direction: column;
            }

            ::slotted(*) {
                overflow: hidden;
                max-height: ${pxToRem(200)};
                transition: max-height 1s ease-in-out;
                position: relative;
            }

            ::slotted(*)::after {
                background: linear-gradient(0deg, #fff, hsla(0, 0%, 100%, 0) 40%);
                bottom: 0;
                content: "";
                height: 100%;
                pointer-events: none;
                position: absolute;
                width: 100%;
                left: 0;
                right: 0;
            }

            input[type="checkbox"] {
                display: none;
            }

            input[type="checkbox"]:checked + ::slotted(*) {
                max-height: fit-content;
            }
            
            input[type="checkbox"]:checked + ::slotted(*)::after {
                display: none;
            }

            input[type="checkbox"]:checked ~ .show-more-label i {
                transform: rotate(225deg);
                    // left: ${pxToRem(140)};
                top: ${pxToRem(1)};
            }

            input[type="checkbox"]:checked ~ .show-more-label .view-more {
                display: none;
            }

            input[type="checkbox"]:checked ~ .show-more-label .view-less {
                display: block;
            }

            .show-more-label {
                color: var(--wl-show-more-label-color, #000);
                font-weight: 600;
                line-height: ${pxToRem(14.4)};
                font-size: ${pxToRem(16)};
                display: flex;
                align-items: center;
                justify-content: initial;
                gap: ${pxToRem(5)};
                cursor: pointer;
                text-align: left;
                margin-top: ${pxToRem(16)};
            }

            .show-more-label i {
                content: "";
                display: block;
                box-sizing: border-box;
                width: ${pxToRem(8)};
                height: ${pxToRem(8)};
                border-bottom: ${pxToRem(2)} solid;
                border-right: ${pxToRem(2)} solid;
                transform: rotate(45deg);
                position: relative;
                top: ${pxToRem(-2)};
            }

            .view-more {
                display: block;
            }

            .view-less {
                display: none;
            }
        `
    }

    connectedCallback() {
        super.connectedCallback();
    }

    protected render() {
        return html`
            <div class="show-more-wrapper">
                <input type="checkbox" id="show-more">
                <slot></slot>
                <label for="show-more" class="show-more-label">
                    <span class="view-more">${this.viewMoreLabel}</span>
                    <span class="view-less">${this.viewLessLabel}</span>
                    <i></i>
                </label>
            </div>
        `
    //     <input type="checkbox" id="show-more">
        //                         <div class="content__other__links">
        //                             <div>
        //                                 ${links.take(3).joinToString("") { it.render() }.trimIndent()}
        //                             </div>
        //                             <div class="optional">
        //                                 ${links.drop(3).joinToString("") { it.render() }.trimIndent()}
        //                             </div>
        //                         </div>
        //                         <label for="show-more" class="content__other__show-more">
        //                             <span class="more">${translations.serp.interlinking.viewMore}</span>
        //                             <span class="less">${translations.serp.interlinking.viewLess}</span>
        //                         <i></i>
        //                         </label>
    }

    // protected _renderBadge() {
    //     if (this.number) {
    //         return html`<wl-badge>${this.number}</wl-badge>`
    //     }
    //
    //     if (!this.withCrossIcon) {
    //         return nothing
    //     }
    //
    //     return html`
    //         <wl-badge class="badge" @click="${this._clickOnCross}"><wl-icon icon="cross"></wl-icon></wl-badge>
    //     `
    // }

    // private _clickOnCross() {
    //     this.dispatchEvent(new WlTagClose(this.innerText));
    // }
}

// export class WlTagClose extends Event {
//     public value: string
//
//     constructor(value: string) {
//         super('wl-tag-close', {bubbles: true, composed: true});
//         this.value = value
//     }
// }
